import React from 'react';
import { useCompanyDateTime } from '@innovyze/stylovyze';
import { formatDateOnly } from '@Utils/formatDateOnly';
import { AttributeCell } from './AttributeCell';
import { InspectionRerunWarning } from './InspectionRerunWarning';

interface LastInspectedCellProps {
	value: string | null | undefined;
	rerunNeeded?: boolean;
}

export const LastInspectedCell = ({
	value,
	rerunNeeded = false,
}: LastInspectedCellProps) => {
	const { dateFormat } = useCompanyDateTime();
	const formatted = formatDateOnly(value, dateFormat || 'yyyy-MM-dd');
	return (
		<span style={{ display: 'inline-flex', alignItems: 'center' }}>
			<AttributeCell value={formatted} />
			{rerunNeeded && <InspectionRerunWarning />}
		</span>
	);
};
